import React, { useEffect, useMemo, useState } from 'react';

// Small animated badge that toggles between two frames.
// By default expects files in public/ as /animation-1.png and /animation-2.png.
// Also tries to fallback to the root-level names with spaces if present on server.

const pickFirstReachable = (candidates) => {
  return new Promise((resolve) => {
    const tryNext = (i) => {
      if (i >= candidates.length) return resolve(null);
      const img = new Image();
      img.onload = () => resolve(candidates[i]);
      img.onerror = () => tryNext(i + 1);
      img.src = candidates[i];
    };
    tryNext(0);
  });
};

const AnimatedBadge = ({ size = 60, intervalMs = 600 }) => {
  const [frame, setFrame] = useState(0);
  const [srcs, setSrcs] = useState([null, null]);

  const candidates1 = useMemo(() => [
    '/animation-1.png',
    '/visa-docs-animation%201.png'
  ], []);
  const candidates2 = useMemo(() => [
    '/animation-2.png',
    '/visa-docs-animation%202.png'
  ], []);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      pickFirstReachable(candidates1),
      pickFirstReachable(candidates2)
    ]).then(([a, b]) => {
      if (!mounted) return;
      setSrcs([a, b]);
    });
    return () => { mounted = false; };
  }, [candidates1, candidates2]);

  useEffect(() => {
    const t = setInterval(() => setFrame((f) => (f === 0 ? 1 : 0)), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);

  const src = srcs[frame] || srcs[0] || null;
  if (!src) return null;

  return (
    <img
      src={src}
      alt="animation"
      className="animated-badge"
      style={{ width: size, height: size }}
    />
  );
};

export default AnimatedBadge;
